/*! StartNoStringValidationRegion user types Formats */
export enum UserType {
  Contact = "OC",
  Staff = "GS",
  Person = "PER",
}
/*! EndNoStringValidationRegion */
